<template>
 <div class="catalogue">
    <div class="top">
      目录
    </div>
    <div class="bottom">
      <div
        v-for="(item, idx) in taskDataMenu"
        :key="idx"
        :class="['bottom-row', {active: index == idx }]"
        @click="handlePage(idx)"
      >
        <div />
        <p>{{item.name}}</p>
      </div>
    </div>
    <!-- <div class="catalogue-pagination">
      <a-pagination simple :default-current="2" :total="50" />
    </div> -->
  </div>
</template>
<script>
export default {
  props: ['taskDataMenu', 'type', 'index'],
  watch: {
    "index":{  
      handler: function(newValue){
        console.log('newValue', newValue)
        setTimeout(() => {
          document.querySelector(`.${this.type} .catalogue`).scrollTop =  document.querySelector(`.${this.type} .active`).offsetTop
        }, 500)
      },
      immediate: true, // 首次绑定值 是否 触发
      deep:true   // 深度监听
    }
  },
  methods: {
    handlePage(index) {
      
      this.$emit('handlePageSize', {
        type: this.type,
        size: index
      })
    }
  }
}
</script>
<style lang="less">
.catalogue {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;

  .top {
    width: 100%;
    min-height: 50px;
    background: #FEF6EA;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #523D28;
  }

  .bottom {
    flex: 1;
    background: #fff;
    padding: 25px 20px 10px 20px;

    &-row {
      text-align: start;
      margin-bottom: 10px;
      cursor: pointer;

      &.active {
        background: #CBAB7A;
        border-radius: 5px;
        p {
          color: #fff !important;
        }

        div {
          background-color: #fff;
        }
      }
      
      span:nth-child(1) {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a0a0a0;
      }

      span:nth-child(2) {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }

      div {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #CBAB7A;
        display:  inline-block;
        margin-right: 10px;
        margin-left: 5px;
      }

      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #947243;
        display:  inline-block;
      }
    }
  }

  &-pagination {
    position: absolute;
    left: 40px;
    right: 40px;
    bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

</style>